import React, { useEffect, useContext } from 'react';

import { BasePage, StaticContext, Helmet } from '@sm/webassets';
import { Box } from '@wds/box';
import { Grid } from '@wds/grid';

import JumboHeader from './components/JumboHeader';
import ModernHeader from '../../components/ModernHeader';
import waitForUsabilla from '~app/helpers/waitForUsabilla';
import FilterNav from '../../components/FilterNav';
import UCSModule from '../../../components/UCSModule';
import { CategoriesProvider } from '../../components/CategoriesContext';
import { SearchProvider } from '../../components/SearchContext';

import getCanonicalUrlOrNoIndex from '~app/helpers/getCanonicalUrlOrNoIndex';
import SearchBox from './components/SearchBox';
import Listings from './Listings';
import { AppListingProvider } from './components/AppListingContext';

const HomeV2 = () => {
  useEffect(() => {
    waitForUsabilla(() => {
      window.usabilla_live('show');
      window.usabilla_live('setForm', 'APP DIRECTORY');
    });
  }, []);

  const {
    environment: { subdomain, domain, tld },
    user,
    url,
  } = useContext(StaticContext);

  const { noIndex, canonicalUrl } = getCanonicalUrlOrNoIndex(subdomain, domain, tld, url);

  return (
    <div data-testid="HomeV2__AppsDirectory">
      <CategoriesProvider>
        <BasePage pageId="App Directory - Home" includeHeader={false} pageMetricsAttributes={null} legacyWeb="papi">
          <Helmet>
            <If condition={!noIndex}>
              <link rel="canonical" href={canonicalUrl} />
            </If>
            <If condition={noIndex}>
              <meta name="robots" content="noindex, nofollow" />
            </If>
          </Helmet>
          <>
            <ModernHeader v2="true" />
            <JumboHeader />
          </>
          <If condition={user.isAuthenticated}>
            <UCSModule moduleName="top_bar" customLoader={<div />} />
          </If>
          <SearchProvider>
            <Box px={8}>
              <Box my={4}>
                <Grid noBleeds noGutters>
                  <Grid.Item sm={3}>
                    <SearchBox />
                  </Grid.Item>
                </Grid>
              </Box>
              <Box display="grid" gridTemplateRows="100vh">
                <Box display="grid" gridTemplateColumns="25% auto" gap={4}>
                  <FilterNav />
                  <Box>
                    <Helmet>
                      <title>SurveyMonkey App Directory &amp; Integrations</title>
                      <meta
                        name="description"
                        content="Integrate with over 100+ SurveyMonkey apps and plug-ins to get more done"
                      />
                    </Helmet>
                    <AppListingProvider>
                      <Listings />
                    </AppListingProvider>
                  </Box>
                </Box>
              </Box>
            </Box>
          </SearchProvider>
        </BasePage>
      </CategoriesProvider>
    </div>
  );
};

export default HomeV2;
